import React, {useContext, useEffect, useState} from 'react';
import Drawer from 'components/Drawer';
import UserEditForm from 'features/user/UserEditForm';
import InvitationsForm from 'features/userInvitation/InvitationsForm';
import HrTable from 'features/hr/HrTable';
import {TitleContext} from '../../components/TitleContext';

const HrPage: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isNewDrawerOpen, setIsNewDrawerOpen] = useState(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const openNewDrawer = () => setIsNewDrawerOpen(true);
  const closeNewDrawer = () => setIsNewDrawerOpen(false);
  const {setTitle} = useContext(TitleContext);

  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']  ">
          Human Resources
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal ">
          Manage your employees and compliance
        </div>
      </div>,
    );
  }, [setTitle]);

  return (
    <div className="">
      <div className="relative overflow-hidden">
        <>
          <HrTable openNewDrawer={openNewDrawer} openDrawer={openDrawer} />
          <Drawer isOpen={isDrawerOpen} onClose={closeDrawer}>
            <UserEditForm onClose={closeDrawer} source="HrTable" />
          </Drawer>
        </>
        <Drawer isOpen={isNewDrawerOpen} onClose={closeNewDrawer}>
          <InvitationsForm
            closeDrawer={closeNewDrawer}
            isDrawerOpen={isNewDrawerOpen}
            source={'HrTable'}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default HrPage;
